import { Injectable } from 'angular-ts-decorators';

import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';
import type { IStandardErrorParser } from '@shared/app/scripts/services/standard-error-parser';
import { ReceivingsModel } from '@classes/receivings-model';

// TODO remove in favor of ReceivingsModel
/**
 * [deprecated] use {@link ReceivingsModel} instead.
 */
export interface IReceivingsModel {
  _id: string;
  id: string;
  docNumber: string;
  remarks: string;
  warehouseId: string;
  skus: any[];
  active: boolean;
  status: string;
  totalQty: number;
  supplierOrderReference: string[];
}

/**
 * Factory in the coreModule. It takes care of communication with receivings
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 *
 * # Data schema
 *
 * The receivings model
 * {@link https://docs.dev.swcloud.nl/dev/index.html#/data/post_receivings_add
 * is documented with json-schema}
 */
@Injectable('receivings')
export class Receivings extends SpynlBase<ReceivingsModel> {
  IDB_COLLECTION: string;
  constructor(
    $http: ng.IHttpService,
    $q: ng.IQService,
    sentry,
    domain: Domain,
    config: IConfig,
    standardErrorParser: IStandardErrorParser,
    private uuid,
    private localDraft,
  ) {
    'ngInject';

    super(
      $http,
      $q,
      sentry,
      domain,
      config,
      standardErrorParser,
      ReceivingsModel,
    );

    this.location = '/receivings';
    this.IDB_COLLECTION = 'receivings';
  }

  private getReceivingsModel(receivingsId: string): ReceivingsModel {
    return new ReceivingsModel({
      id: receivingsId,
      _id: receivingsId,
      docNumber: receivingsId,
      remarks: '',
      warehouseId: '',
      skus: [],
      active: true,
      status: 'draft',
      totalQty: 0,
      supplierOrderReference: [],
    });
  }

  /**
   * Method that returns a new receivings object
   * @param optional locationId for new receivings
   * @return
   * It will return a new receivings object
   */
  newReceivings(locationId?: string): ReceivingsModel {
    const receivingsId = this.uuid.v4();
    const newReceivings = this.getReceivingsModel(receivingsId);
    newReceivings.warehouseId = locationId;

    return newReceivings;
  }

  /**
   * Method that cancels an order by removing the local version and sets any
   * server side saved version to inactive
   * @param {string} id the order id
   * @return {Promise}
   * It will return a promise
   */
  cancelOrder(id) {
    return this.remove({ _id: id }).then(() => this.removeLocal(id));
  }

  /**
   * Method that removes an order from local and also from the server.
   * @param {string} id the UUID of the order
   * @return {Promise}
   * It will return a promise
   */
  removeLocal(id) {
    return this.localDraft.remove(this.IDB_COLLECTION, id);
  }
}
